"use client"

import { createContext, useContext, useEffect, useState } from "react"

const ThemeProviderContext = createContext({})

export function ThemeProvider({ children, defaultTheme = "system", storageKey = "theme", ...props }) {
   const [theme, setTheme] = useState(() => {
      // First check local storage
      const storedTheme = localStorage.getItem(storageKey)
      if (storedTheme) return storedTheme

      // For auth pages, default to light theme
      const token = localStorage.getItem('token')
      if (!token) return 'light'

      // If system preference is available and no stored theme, use it
      if (defaultTheme === "system") {
         return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
      }

      return defaultTheme
   })

   useEffect(() => {
      const root = window.document.documentElement
      root.classList.remove("light", "dark")

      // set light theme if on auth page
      const token = localStorage.getItem('token')
      if (!token) {
         root.classList.add("light")
         localStorage.setItem(storageKey, "light")
         return
      }

      root.classList.add(theme)
      localStorage.setItem(storageKey, theme)
   }, [theme, storageKey])

   const value = {
      theme,
      setTheme: (newTheme) => {
         localStorage.setItem(storageKey, newTheme)
         setTheme(newTheme)
      },
   }

   return (
      <ThemeProviderContext.Provider {...props} value={value}>
         {children}
      </ThemeProviderContext.Provider>
   )
}

export const useTheme = () => {
   const context = useContext(ThemeProviderContext)

   if (context === undefined)
      throw new Error("useTheme must be used within a ThemeProvider")

   return context
}
